// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"d2a5ee9a","173":"59f09c04","831":"daa6bdbe"}[chunkId] + ".chunk.css";
};